// ** React Imports
import React, {Fragment, useEffect, useState} from 'react'

// ** Table Data & Columns
import { columns } from './data'

// ** Third Party Components
import ReactPaginate from 'react-paginate'
import DataTable from 'react-data-table-component'
import {ChevronDown, PlusSquare} from 'react-feather'

// ** Reactstrap Imports
import {
    Row,
    Col,
    Card,
    Input,
    Label,
    CardTitle,
    CardHeader, Button
} from 'reactstrap'

// ** Styles
import '@styles/react/libs/tables/react-dataTable-component.scss'
import axios from "axios";
import EditSociety from "./components/edit-company/edit-company";
import CreateSociety from "./components/create-company/create-company";

const CompaniesList = () => {
    // ** States
    const [showCreateSocietyModal, setShowCreateSocietyModal] = useState(false);
    const [showEditSocietyModal, setShowEditSocietyModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(0)
    const [searchValue, setSearchValue] = useState('')
    const [data, setData] = useState([])
    const [filteredData, setFilteredData] = useState(data);
    const [rowEdit, setRowEdit] = useState(null);

    const toggleCreateSocietyModal = (show) => {
        setRowEdit(null);
        setShowCreateSocietyModal(show);
    }

    const toggleEditSocietyModal = (show, row) => {
        setShowEditSocietyModal(show);
        setRowEdit(row);
    }

    const getSocieties = async () => {
        const response =  await axios.get(`${process.env.REACT_APP_API_URL}/companies`)
        const societiesList = response?.data.map((item) => {
            return {
                id: item.id,
                name: item.name,
                taxId: item.taxId,
                status: item.status
            }
        });
        setData(societiesList);
    }

    useEffect(() => {
        getSocieties();
    }, []);


    // ** Function to handle filter
    const handleFilter = e => {
        const value = e.target.value
        let updatedData = []
        setSearchValue(value)

        if (value.length) {
            updatedData = data.filter(item => {
                const startsWith =
                    item.id.toString().toLowerCase().startsWith(value.toLowerCase()) ||
                    item.name.toLowerCase().startsWith(value.toLowerCase())
                    item.taxId.toLowerCase().startsWith(value.toLowerCase())
                    item.status.toLowerCase().startsWith(value.toLowerCase())

                const includes =
                    item.id.toString().toLowerCase().includes(value.toLowerCase()) ||
                    item.name.toLowerCase().includes(value.toLowerCase())
                    item.taxId.toLowerCase().includes(value.toLowerCase())
                    item.status.toLowerCase().includes(value.toLowerCase())

                if (startsWith) {
                    return startsWith
                } else if (!startsWith && includes) {
                    return includes
                } else return null
            })
            setFilteredData(updatedData)
            setSearchValue(value)
        }
    }

    // ** Function to handle Pagination
    const handlePagination = page => {
        setCurrentPage(page.selected)
    }

    // ** Pagination Previous Component
    const Previous = () => {
        return (
            <Fragment>
                <span className='align-middle d-none d-md-inline-block'>Anterior</span>
            </Fragment>
        )
    }

    // ** Pagination Next Component
    const Next = () => {
        return (
            <Fragment>
                <span className='align-middle d-none d-md-inline-block'>Siguiente</span>
            </Fragment>
        )
    }

    // ** Custom Pagination
    const CustomPagination = () => (
        <ReactPaginate
            previousLabel={<Previous />}
            nextLabel={<Next />}
            forcePage={currentPage}
            onPageChange={page => handlePagination(page)}
            pageCount={searchValue.length ? Math.ceil(filteredData.length / 20) : Math.ceil(data.length / 20) || 1}
            breakLabel={'...'}
            pageRangeDisplayed={2}
            marginPagesDisplayed={2}
            activeClassName={'active'}
            pageClassName={'page-item'}
            nextLinkClassName={'page-link'}
            nextClassName={'page-item next'}
            previousClassName={'page-item prev'}
            previousLinkClassName={'page-link'}
            pageLinkClassName={'page-link'}
            breakClassName='page-item'
            breakLinkClassName='page-link'
            containerClassName={'pagination react-paginate pagination-sm justify-content-end pe-1 mt-1'}
        />
    )

    return (
        <Fragment>
            <Card>
                <CardHeader className='flex-md-row flex-column align-md-items-center align-items-start border-bottom'>
                    <CardTitle tag='h4'>Empresas</CardTitle>
                </CardHeader>

                <Row className='justify-content-end mx-0'>
                    <Col className='d-flex justify-content-end mt-1' md='6' sm='12'>
                        <Button
                            onClick={() => {
                                toggleCreateSocietyModal(true);
                            }}
                            color='primary'
                            className='btn-sm'>
                            <PlusSquare size={16} />
                            <span className={'ms-1'}>Crear Sociedad</span>
                        </Button>
                    </Col>
                </Row>
                < hr/>

                <Row className='justify-content-end mx-0'>
                    <Col className='d-flex align-items-center justify-content-end mt-1' md='6' sm='12'>
                        <Label className='me-1' for='search-input'>
                            Buscar
                        </Label>

                        <Input
                            className='dataTable-filter mb-50'
                            type='text'
                            bsSize='sm'
                            id='search-input'
                            value={searchValue}
                            onChange={handleFilter}
                        />
                    </Col>
                </Row>
                    <div className='react-dataTable'>
                        <DataTable
                            noHeader
                            pagination
                            columns={columns(toggleEditSocietyModal)}
                            paginationPerPage={20}
                            className='react-dataTable'
                            sortIcon={<ChevronDown size={10} />}
                            paginationComponent={CustomPagination}
                            paginationDefaultPage={currentPage + 1}
                            data={searchValue.length ? filteredData : data}
                        />
                    </div>
            </Card>

            <CreateSociety isOpen={showCreateSocietyModal} handleClose={toggleCreateSocietyModal} />
            <EditSociety isOpen={showEditSocietyModal} handleClose={toggleEditSocietyModal} item={rowEdit}/>

        </Fragment>
    )
}

export default CompaniesList
